// Field metadata + value formatting for the audit-log screens.
//
// The API returns whole Mongoose documents in `oldData` / `newData`. Most of
// those keys are storage plumbing the user can never act on (`_id`, `__v`,
// timestamps, credentials), so they are dropped before anything is rendered.
// Sub-documents (sale/buy line tables) are diffed separately.
//
// FIELD_LABELS covers the payload keys the ERP actually posts (see the
// `Instance.post("/api/v1/new*")` calls in Context/AddProWakel.js) — those are
// the exact names that come back in the audit documents.

import {
    STATUS_LABELS,
    UNIT_LABELS,
    CURRENCY_LABELS,
    ROLE_LABELS,
} from "../shared/valueLabels";

// Keys never shown, in the top-level diff or inside a sub-table row.
const NOISE_KEYS = new Set([
    "_id",
    "id",
    "__v",
    "__t",
    "createdAt",
    "updatedAt",
    "password",
    "passwordCheck",
    "token",
    "resetToken",
]);

export const SUB_TABLE_KEYS = ["saleTable", "BuyTable", "table"];

export const FIELD_LABELS = {
    // ── Product ────────────────────────────────────────────
    code: "کۆد",
    productCode: "کۆدی کاڵا",
    barcode: "باڕکۆد",
    name: "ناو",
    nameofproduct: "ناوی کاڵا",
    price: "نرخی کڕین",
    saleDinar: "نرخی فرۆشتن (دینار)",
    saleDolar: "نرخی فرۆشتن (دۆلار)",
    saleOfLessHalfCarton: "نرخی کەمتر لە نیو کارتۆن",
    saleOfLessTenDarzan: "نرخی کەمتر لە دە دەرزەن",
    numberOfDarzan: "دەرزەن لە کارتۆن",
    numberOfDana: "دانە لە دەرزەن",
    qazanj: "قازانج",
    qazanj2: "قازانج ٢",
    qazanj2_IQD: "قازانج ٢ (دینار)",
    qazanjywasl: "قازانجی وەسڵ",
    rasidKarton: "ڕەسیدی کارتۆن",
    weight: "کێش",
    Karton_price: "نرخی کارتۆن",
    kartonPrice: "نرخی کارتۆن",
    priceOneRRR: "نرخی یەک ڕیمێمبی",
    height: "بەرزی",
    width: "پانی",
    length: "درێژی",
    metr: "مەتر",
    remembi: "ڕیمێمبی",
    zhmarayDwkan: "ژمارەی دوکان",
    dp: "دەرزەن-پاکەت",
    dnk: "دانە لە کارتۆن",
    nrxifroshtnkarton: "نرخی فرۆشتنی کارتۆن",
    nrxifroshtnkarton2: "نرخی فرۆشتنی کارتۆن ٢",
    nrxifroshtnkarton2_IQD: "نرخی فرۆشتنی کارتۆن ٢ (دینار)",
    nsbayfrohtn: "٪ فرۆشتن",
    nsbayfrohtn2: "٪ فرۆشتن ٢",
    nsbayfrohtn2_IQD: "٪ فرۆشتن ٢ (دینار)",
    nrxeFroshtnDolar2: "نرخی فرۆشتنی دۆلار ٢",
    nrxeFroshtnDenar2: "نرخی فرۆشتنی دینار ٢",
    Chine_invoice: "پسوڵەی چین",
    singleSale: "فرۆشتنی مفرەد",
    detail: "وردەکاری",
    rezha: "ڕێژە",
    font: "فۆنت",
    display: "پیشاندان",
    number: "ژمارە",
    nrx: "نرخ",
    nrxID: "نرخ (دینار)",
    isPublished: "بڵاوکراوەتەوە",
    images: "رسمکان",

    // ── Sale / Buy ─────────────────────────────────────────
    numberOfWakil: "کۆدی وەکیل",
    wakil: "وەکیل",
    wakilcode: "کۆدی وەکیل",
    namewakil: "ناوی وەکیل",
    whossale: "کێ فرۆشتی",
    froshtn: "جۆری فرۆشتن",
    saleTable: "کاڵاکانی فرۆشتن",
    BuyTable: "کاڵاکانی کڕین",
    table: "خشتە",
    joripara: "جۆری دراو",
    koalldinar: "کۆی گشتی (دینار)",
    koalldolar: "کۆی گشتی (دۆلار)",
    dashkandinar: "داشکان (دینار)",
    dashkandolar: "داشکان (دۆلار)",
    paraydrawdinar: "پارەی دراو (دینار)",
    paraydrawdolar: "پارەی دراو (دۆلار)",
    paraymawadinar: "پارەی ماوە (دینار)",
    paraymawadolar: "پارەی ماوە (دۆلار)",
    qarzinwedinar: "قەرزی نوێ (دینار)",
    qarzinwedolar: "قەرزی نوێ (دۆلار)",
    zhmaraaywasl: "ژمارەی وەسڵ",
    zh_wasl: "ژمارەی وەسڵ",
    DolarPrice: "نرخی دۆلار",
    navdolar: "نرخی دۆلار",
    FIB: "پارەی بانک (FIB)",
    cash: "کاش",
    owe: "قەرز",
    R_Mufrad_check: "فرۆشتنی مفرەد",
    typePay: "شێوازی پارەدان",
    wasl: "وەسڵ",
    total: "کۆی گشتی",
    totalID: "کۆی گشتی (دینار)",
    totalDollar: "کۆی گشتی (دۆلار)",
    dashkan: "داشکان",
    dashkanID: "داشکان (دینار)",

    // ── Wakil / Apeopple ───────────────────────────────────
    Name: "ناو",
    phone: "مۆبایل",
    Phone: "مۆبایل",
    adress: "ناونیشان",
    address: "ناونیشان",
    City: "شار",
    jor: "جۆر",
    rejaDolar: "قەرز دۆلار",
    rejaDinar: "قەرز دینار",
    paradolar: "پارە (دۆلار)",
    paradinar: "پارە (دینار)",

    // ── Para / Pardan / Mandwb / Paradarhenan / Parawargrtn ─
    briparabadolar: "بڕی پارە (دۆلار)",
    briparabadinar: "بڕی پارە (دینار)",
    briparabaRRR: "بڕی پارە (ڕیمێمبی)",
    paraywargirawdolar: "پارەی وەرگیراو (دۆلار)",
    paraywargirawdinar: "پارەی وەرگیراو (دینار)",
    paraywargirawrem: "پارەی وەرگیراو (ڕیمێمبی)",
    kmkrdnawa: "کەمکردنەوە",
    paradwaykmkrdndolar: "پارە دوای کەمکردنەوە (دۆلار)",
    paradwaykmkrdndinar: "پارە دوای کەمکردنەوە (دینار)",
    nawiwargr: "ناوی وەرگر",
    nawikas: "ناوی کەس",
    rasiddolar: "ڕەسیدی دۆلار",
    rasiddinar: "ڕەسیدی دینار",
    rasidkondolar: "ڕەسیدی کۆن (دۆلار)",
    rasiddkoninar: "ڕەسیدی کۆن (دینار)",
    rasiddkonRR: "ڕەسیدی کۆن (ڕیمێمبی)",
    rasiddkonRRR: "ڕەسیدی کۆن (ڕیمێمبی)",
    jwlla: "جوڵە",
    parayPechawana: "پارەی پێچەوانە",
    koypara: "کۆی پارە",
    shwen: "شوێن",
    nrxe_RRR: "نرخی ڕیمێمبی",
    nrxe_RRR_2: "نرخی ڕیمێمبی ٢",
    Krini_RRR: "کڕینی ڕیمێمبی",
    Kreni_dinar: "کڕینی دینار",
    Nrxi_yakDolar: "نرخی یەک دۆلار",
    Amount_Dolar: "بڕی دۆلار",
    Amount_Dinar: "بڕی دینار",
    High_Dolar: "بەرزترین دۆلار",
    Low_Dolar: "نزمترین دۆلار",
    Remebi_Price: "نرخی ڕیمێمبی",
    DinarTR: "دینار (TR)",
    DolarTR: "دۆلار (TR)",
    MM_lastPayment: "دوایین پارەدان",
    date: "بەروار",
    note: "تێبینی",
    Note: "تێبینی",

    // ── User ───────────────────────────────────────────────
    username: "ناوی بەکارهێنەر",
    role: "دەسەڵات",

    // ── Online order ───────────────────────────────────────
    orderNumber: "ژمارەی داواکاری",
    customer: "کڕیار",
    items: "کاڵاکان",
    subtotal: "کۆی بەشەکان",
    currency: "دراو",
    status: "دۆخ",
    staffNote: "تێبینی کارمەند",
    saleRef: "پسوڵەی پەیوەندیدار",
    handledBy: "چارەسەرکراو لەلایەن",
    handledAt: "بەرواری چارەسەرکردن",
    unit: "یەکە",
    quantity: "بڕ",
    unitPrice: "نرخی یەکە",
    lineTotal: "کۆی ڕیز",

    // ── Sale / Buy line items (sub-table rows) ─────────────
    carton: "کارتۆن",
    karton: "کارتۆن",
    darzan: "دەرزەن",
    dana: "دانە",
    nawisht: "ناوی کاڵا",
    jamaraysht: "ژمارەی کاڵا",
    raqam: "ڕەقەم",
    reja: "ڕێژە",
    kodinar: "کۆ (دینار)",
    kodolar: "کۆ (دۆلار)",
    koy: "کۆ",
    koyID: "کۆ (دینار)",
};

export const MODEL_LABELS = {
    Product: "کاڵا",
    ProductTable: "تێبلی کاڵا",
    Sale: "فرۆشتن",
    Buy: "کڕین",
    Broken: "شکان",
    Wakil: "وەکیل",
    Para: "پارە",
    Pardan: "پارەدان",
    Mandwb: "مەندوب",
    Garanawa: "گەڕانەوە",
    Masrwfat: "مەسروفات",
    Apeopple: "کەس",
    Paradarhenan: "پارەدەرهێنان",
    Parawargrtn: "پارەوەرگرتن",
    Paraybardast: "پارەی بەردەست",
    ParaGorinawa: "پارە گۆڕینەوە",
    User: "بەکارهێنەر",
    Rent: "کرێ",
    TesxtOnBord: "قەرزی دەفتەر",
    Setting: "ڕێکخستن",
    Order: "داواکاری ئۆنڵاین",
    PriceUpdate: "نوێکردنەوەی نرخ",
};

export const ACTION_LABELS = {
    CREATE: "زیادکردن",
    UPDATE: "گۆڕانکاری",
    DELETE: "سڕینەوە",
};

// Stored enum values that would otherwise render as raw English, keyed by the
// field they belong to.
const VALUE_LABELS = {
    unit: UNIT_LABELS,
    currency: CURRENCY_LABELS,
    role: ROLE_LABELS,
    status: STATUS_LABELS,
};

export const fieldLabel = (key) => FIELD_LABELS[key] || key;
export const modelLabel = (model) => MODEL_LABELS[model] || model || "-";
export const actionLabel = (action) => ACTION_LABELS[action] || action || "-";

export const EMPTY = "—";

const ISO_DATE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;
const groups = new Intl.NumberFormat("en-US");

export const formatDate = (value) => {
    if (!value) return EMPTY;
    const date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    return date.toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
};

const truncate = (text, max) =>
    text.length > max ? `${text.slice(0, max - 1)}…` : text;

// Renders one stored value as a short, human-readable string.
export const formatValue = (value) => {
    if (value === undefined || value === null || value === "") return EMPTY;
    if (typeof value === "boolean") return value ? "بەڵێ" : "نەخێر";
    if (typeof value === "number") return groups.format(value);
    if (Array.isArray(value)) return `${value.length} دانە`;
    if (typeof value === "object") return truncate(JSON.stringify(value), 60);

    const text = String(value);
    if (ISO_DATE.test(text)) return formatDate(text);
    if (text.trim() !== "" && !isNaN(text) && Math.abs(Number(text)) >= 1000) {
        return groups.format(Number(text));
    }
    return text;
};

// Same as formatValue, but translates the enum values of fields whose stored
// form is English (`unit`, `currency`, `role`, `status`).
export const formatFieldValue = (key, value) => {
    const table = VALUE_LABELS[key];
    if (table && typeof value === "string" && table[value]) return table[value];
    return formatValue(value);
};

// What "changed" is decided on, never on the rendered string: an array renders
// as its length and an object is truncated, so two different values could print
// identically and a real edit would be filtered out of the diff.
const comparable = (value) => {
    if (value === undefined || value === null) return "";
    if (typeof value === "object") return JSON.stringify(value);
    return formatValue(value);
};

export const valuesEqual = (a, b) => comparable(a) === comparable(b);

const visibleKeys = (...objects) => {
    const keys = new Set();
    objects.forEach((obj) =>
        Object.keys(obj || {}).forEach((key) => {
            if (!NOISE_KEYS.has(key)) keys.add(key);
        })
    );
    return [...keys];
};

// Top-level field diff. Sub-tables are excluded — they get their own renderer.
// `onlyChanged` (the default) is what makes the modal readable: an UPDATE that
// touched one price no longer prints forty identical rows.
export const diffFields = (oldData, newData, onlyChanged = true) => {
    const rows = visibleKeys(oldData, newData)
        .filter((key) => !SUB_TABLE_KEYS.includes(key))
        .map((key) => {
            const rawBefore = (oldData || {})[key];
            const rawAfter = (newData || {})[key];
            return {
                key,
                before: formatFieldValue(key, rawBefore),
                after: formatFieldValue(key, rawAfter),
                changed: comparable(rawBefore) !== comparable(rawAfter),
            };
        });
    return onlyChanged ? rows.filter((row) => row.changed) : rows;
};

// Flat snapshot of a single record — used for DELETE (no `newData` to compare
// against) so the modal shows what was removed instead of a column of dashes.
export const snapshotFields = (data) =>
    visibleKeys(data)
        .filter((key) => !SUB_TABLE_KEYS.includes(key))
        .map((key) => ({ key, value: formatFieldValue(key, (data || {})[key]) }))
        .filter((row) => row.value !== EMPTY);

// Column keys of a sub-table (line items), noise removed.
export const subTableKeys = (oldItems, newItems) => {
    const keys = new Set();
    [...oldItems, ...newItems].forEach((item) =>
        Object.keys(item || {}).forEach((key) => {
            if (!NOISE_KEYS.has(key)) keys.add(key);
        })
    );
    return [...keys];
};

// ── Per-log memoisation ────────────────────────────────────────────
// Every derivation below walks whole Mongoose documents (`oldData` + `newData`,
// line-item arrays included). The list renders each log and the search box
// re-scans every log, so without a cache the same deep walk ran again on every
// render and every keystroke — that is what made the screen freeze. Logs are
// plain objects replaced only when a fetch resolves, so a WeakMap keyed on the
// log itself caches for exactly as long as the log is on screen and never
// leaks.
const memoPerLog = (compute) => {
    const cache = new WeakMap();
    return (log) => {
        if (!log || typeof log !== "object") return compute(log);
        const hit = cache.get(log);
        if (hit !== undefined) return hit;
        const value = compute(log);
        cache.set(log, value);
        return value;
    };
};

// Labels of the sub-tables (line-item arrays) an UPDATE touched.
export const changedSubTableLabels = memoPerLog((log) => {
    if (!log || log.action !== "UPDATE") return [];
    return SUB_TABLE_KEYS.filter((key) => {
        const before = (log.oldData || {})[key];
        const after = (log.newData || {})[key];
        if (!before && !after) return false;
        return JSON.stringify(before) !== JSON.stringify(after);
    }).map(fieldLabel);
});

// ── Line-item (sub-table) diff ─────────────────────────────────────
// Keys inside a line-item row that are plumbing rather than data anyone edited:
// the row uuid and the three "which unit did the user type in" flags the sale
// screen writes alongside the numbers.
const ITEM_NOISE_KEYS = new Set([
    "uuid",
    "danaChanged",
    "darzanChanged",
    "kartonChanged",
]);

const itemIdentity = (item) => {
    const src = item || {};
    const pick = (keys) => {
        for (const key of keys) {
            const v = src[key];
            if (v !== undefined && v !== null && v !== "" && v !== 0 && v !== "0")
                return String(v);
        }
        return "";
    };
    return {
        code: pick(["jamaraysht", "raqam", "code", "productCode"]),
        name: pick(["nawisht", "nameofproduct", "name"]),
    };
};

// Rows are matched on their own identity (the row uuid, else the product ref),
// never on position: inserting one line in the middle of an invoice must not
// report every line under it as edited. The same product listed twice gets an
// occurrence suffix so the two rows stay distinct.
const indexItems = (items) => {
    const map = new Map();
    const seen = {};
    (Array.isArray(items) ? items : []).forEach((item, i) => {
        const base = item && (item.uuid || item._id);
        let key;
        if (base === undefined || base === null || base === "") {
            key = `@${i}`;
        } else {
            seen[base] = (seen[base] || 0) + 1;
            key = `${base}#${seen[base]}`;
        }
        map.set(key, item || {});
    });
    return map;
};

const diffItemFields = (before, after) =>
    subTableKeys([before], [after])
        .filter((key) => !ITEM_NOISE_KEYS.has(key))
        .filter((key) => comparable(before[key]) !== comparable(after[key]))
        .map((key) => ({
            key,
            label: fieldLabel(key),
            before: formatFieldValue(key, before[key]),
            after: formatFieldValue(key, after[key]),
        }));

// Only the line items an UPDATE actually touched — added, removed, or edited —
// each with the fields that moved. An invoice with forty lines where one carton
// count was fixed reports that one line, not "the item table changed".
export const changedSubTableItems = memoPerLog((log) => {
    if (!log || log.action !== "UPDATE") return [];
    const out = [];
    SUB_TABLE_KEYS.forEach((tableKey) => {
        const before = (log.oldData || {})[tableKey];
        const after = (log.newData || {})[tableKey];
        if (!Array.isArray(before) && !Array.isArray(after)) return;
        if (JSON.stringify(before) === JSON.stringify(after)) return;

        const oldItems = indexItems(before);
        const newItems = indexItems(after);
        const table = fieldLabel(tableKey);
        [...new Set([...oldItems.keys(), ...newItems.keys()])].forEach((key) => {
            const oldItem = oldItems.get(key);
            const newItem = newItems.get(key);
            const id = `${tableKey}:${key}`;
            if (!oldItem) {
                out.push({ id, table, kind: "added", item: itemIdentity(newItem), fields: [] });
            } else if (!newItem) {
                out.push({ id, table, kind: "removed", item: itemIdentity(oldItem), fields: [] });
            } else {
                const fields = diffItemFields(oldItem, newItem);
                if (fields.length > 0) {
                    const identity = itemIdentity(newItem);
                    out.push({
                        id,
                        table,
                        kind: "changed",
                        item: identity.code || identity.name ? identity : itemIdentity(oldItem),
                        fields,
                    });
                }
            }
        });
    });
    return out;
});

// The top-level fields an UPDATE touched, WITH their before/after values — the
// list shows every one of these so a price change reads "کۆن → نوێ" at a glance
// instead of only naming the field.
export const changedFieldDetails = memoPerLog((log) => {
    if (!log || log.action !== "UPDATE") return [];
    return diffFields(log.oldData, log.newData).map((row) => ({
        key: row.key,
        label: fieldLabel(row.key),
        before: row.before,
        after: row.after,
    }));
});

// Names of the fields an UPDATE touched — the flat form, used by the search
// index. Built from the memoised detail list so it costs no extra diffing.
export const changedFieldLabels = memoPerLog((log) => {
    if (!log || log.action !== "UPDATE") return [];
    const items = changedSubTableItems(log);
    return [
        ...changedFieldDetails(log).map((row) => row.label),
        ...changedSubTableLabels(log),
        ...items.map((entry) => entry.item.name),
        ...items.map((entry) => entry.item.code),
        ...items.flatMap((entry) => entry.fields.map((f) => f.label)),
    ].filter(Boolean);
});

// Models whose audited record is a catalogue item (a product). For these the
// list surfaces the item's code + name so a row can be recognised without
// opening it.
const PRODUCT_MODELS = new Set(["Product", "ProductTable"]);
export const isProductLog = (log) => PRODUCT_MODELS.has(log && log.modelName);

// Models whose audited record is an invoice made out to a customer (wakil).
const SALE_MODELS = new Set(["Sale", "Buy", "Rent"]);
export const isSaleLog = (log) => SALE_MODELS.has(log && log.modelName);

// First non-empty value among `keys`, taken from whichever snapshot exists —
// an UPDATE keeps both, a DELETE only `oldData`.
const pickField = (log, keys) => {
    for (const src of [(log && log.newData) || {}, (log && log.oldData) || {}]) {
        for (const key of keys) {
            const v = src[key];
            if (v !== undefined && v !== null && v !== "") return String(v);
        }
    }
    return "";
};

// The identifying code + name of the product a log refers to.
export const productIdentity = (log) => {
    if (!isProductLog(log)) return null;
    const code = pickField(log, ["code", "productCode", "barcode"]);
    const name = pickField(log, ["nameofproduct", "name"]);
    if (!code && !name) return null;
    return { code, name };
};

// The customer an invoice was made out to: their number (`numberOfWakil`) and
// name (`wakil`). Cash/مفرد sales carry no number, so the name stands alone.
export const customerIdentity = (log) => {
    if (!isSaleLog(log)) return null;
    const code = pickField(log, ["numberOfWakil", "wakilcode", "numberofwakil"]);
    const name = pickField(log, ["wakil", "namewakil", "Name"]);
    if (!code && !name) return null;
    return { code, name };
};

// What identifies the edited record in the list: a product's code + name, or —
// on a Sale — the customer's number + name, so an invoice row says who it
// belongs to without opening it. `kind` picks the icon.
export const recordIdentity = (log) => {
    const product = productIdentity(log);
    if (product) return { ...product, kind: "product" };
    const customer = customerIdentity(log);
    if (customer) return { ...customer, kind: "customer" };
    return null;
};

// Every scalar reachable inside `value`, collected for the free-text search.
// Sub-documents are walked recursively so line-item names/codes are covered;
// storage-plumbing keys are skipped so they neither match nor add noise.
const collectStrings = (value, out) => {
    if (value === null || value === undefined) return;
    if (Array.isArray(value)) {
        value.forEach((item) => collectStrings(item, out));
        return;
    }
    if (typeof value === "object") {
        Object.entries(value).forEach(([key, v]) => {
            if (!NOISE_KEYS.has(key)) collectStrings(v, out);
        });
        return;
    }
    out.push(String(value));
};

// One lowercase haystack per log for the list search box — covers who/what/when
// plus the full old/new payloads, so item names, codes and prices are all
// searchable, not just the columns that happen to be rendered.
// Memoised: this is the single most expensive derivation (a full recursive walk
// of both payloads), and the search runs it over every loaded log.
export const logSearchText = memoPerLog((log) => {
    if (!log) return "";
    const parts = [
        formatDate(log.createdAt),
        actionLabel(log.action),
        log.action,
        modelLabel(log.modelName),
        log.modelName,
        log.documentId,
        log.ipAddress,
        log.performedBy ? log.performedBy.name : "",
    ];
    const id = recordIdentity(log);
    if (id) parts.push(id.code, id.name);
    changedFieldLabels(log).forEach((label) => parts.push(label));
    collectStrings(log.oldData, parts);
    collectStrings(log.newData, parts);
    return parts.filter(Boolean).join(" ").toLowerCase();
});

// A query is split once per filter pass, not once per row — `searchTerms` does
// the tokenising, `logMatchesTerms` tests one log against the result (AND across
// terms).
export const searchTerms = (query) => {
    const q = (query || "").trim().toLowerCase();
    return q ? q.split(/\s+/) : [];
};

export const logMatchesTerms = (log, terms) => {
    if (!terms || terms.length === 0) return true;
    const haystack = logSearchText(log);
    return terms.every((term) => haystack.includes(term));
};
